module.exports = __webpack_public_path__ + "img/btn-2.899fa92f.png";